import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetMiscInfo',
    props: {
        miscInfo: null
    },
    setup(__props) {
        const props = __props;
        const showErrorHelp = ref(false);
        const sharingError = ref(false);
        // old sharable error: Attempted to create shared output datasets in objectstore with sharing disabled
        // new sharable error: Job attempted to create sharable output datasets in a storage location with sharing disabled
        const sharingErrorRex = /with sharing disabled/g;
        const knownErrors = [{ regex: sharingErrorRex, modalRef: sharingError }];
        const fixable = computed(() => {
            return knownErrors.some((error) => error.modalRef.value);
        });
        function checkForKnownErrors() {
            for (const knownError of knownErrors) {
                const regex = knownError.regex;
                if (props.miscInfo.match(regex)) {
                    knownError.modalRef.value = true;
                }
            }
        }
        watch(props, checkForKnownErrors, { immediate: true });
        function showHelp() {
            showErrorHelp.value = true;
        }
        return { __sfc: true, showErrorHelp, sharingError, sharingErrorRex, knownErrors, props, fixable, checkForKnownErrors, showHelp };
    }
});
